import { Component, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';
import { WebServicesService } from 'src/app/container/internal/internal-home/pages/webservices/webservices.service';
import { HomeExternalService } from 'src/app/container/external/shared/home/home-external.service';
import { VistaRapida } from 'src/app/core/entities/vistarapida.models';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-donas5',
  templateUrl: './donas.component.html',
  styleUrls: ['./donas.component.scss']
})
export class Donas5Component implements OnInit {

  vistaRapidaActivo: VistaRapida = new VistaRapida();

  public doughnutChartType: ChartType = 'doughnut';

  public doughnutChartLabels: string[] = [];
  
  public doughnutChartData: any = {
    labels: [],
    datasets: [
      {
        data: [0, 0, 0, 0],
        backgroundColor: ['#007bff', '#dc3545', '#fd7e14', '#28a745']
      }
    ]
  };

  public chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
  }


  constructor(private translateService: TranslateService,
              private webServicesService : WebServicesService,
              private homeExternalService: HomeExternalService) { }

  ngOnInit() {
    if(this.webServicesService.vistaRapidaObj.active){
      this.vistaRapidaActivo =  _.cloneDeep(this.webServicesService.vistaRapidaObj);
      this.actualizarGrafico();
    }
    if(this.homeExternalService.vistaRapidaObj.active){
      this.vistaRapidaActivo =  _.cloneDeep(this.homeExternalService.vistaRapidaObj);
      this.actualizarGrafico();
    }
  }

  actualizarGrafico(): void {

    this.doughnutChartData.datasets[0].data = [
      +this.vistaRapidaActivo.totExpedAjud,
      +this.vistaRapidaActivo.totExpedSanc,
      +this.vistaRapidaActivo.totExpedTrib,
      +this.vistaRapidaActivo.totExpedAltr
    ];

    this.doughnutChartData.labels = [
      this.translateService.instant('WEBSERVICES.VISTA_RAPIDA.EXPEDIENTE.tabla_ajus'),
      this.translateService.instant('WEBSERVICES.VISTA_RAPIDA.EXPEDIENTE.tabla_multa'),
      this.translateService.instant('WEBSERVICES.VISTA_RAPIDA.EXPEDIENTE.tabla_trib'),
      this.translateService.instant('WEBSERVICES.VISTA_RAPIDA.EXPEDIENTE.tabla_rest')
    ];
  }

  //event
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    //console.log(event, active);
  }

  //event
  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    //console.log(event, active);
  }

}